import { getActiveConversationChatId } from '../../Helpers/Chat/ChatHelper';
import { getIdFromJid } from '../../Helpers/Chat/User';
import logger from '../../Helpers/logger';
import { notifySendBlocked } from '../chatDetail/Composer/sendPermission';
import { markOutboxFailed, OUTBOX_KIND } from './outboxQueue';

export const MESSAGE_ERROR = 'messageError';

// The server's answer when the sender may no longer post to the chat (E36).
const NOT_ALLOWED_CONDITIONS = ['forbidden', 'item-not-found', 'not-allowed'];
const TEXT_MESSAGE_TYPE = 'text';

/**
 * Handles a message the server bounced back (SDK `messageError`, FR103): the message turns
 * "Failed to send" with Retry, and a refusal shows E36 and reloads the open chat.
 *
 * @param {object} event { msgId, toJid, chatType, errorType, condition } from the SDK.
 */
export const handleMessageError = event => async (dispatch, getState) => {
    const { msgId, toJid, condition } = event || {};
    const chatId = getIdFromJid(toJid);
    const message = getState().chatConversationHistory?.data?.[chatId]?.messages?.[msgId];
    logger.warn('Message refused by the server', { msgId, condition });
    if (!message) return;

    const receiptStatus = getState().privacySettingsData?.seenReceipt === 0 ? '0' : '1';
    const item = toOutboxItem(message, toJid, receiptStatus);
    if (item) await dispatch(markOutboxFailed(item));
    if (!NOT_ALLOWED_CONDITIONS.includes(condition)) return;
    // Other chats reload their state when they are opened.
    dispatch(notifySendBlocked(getActiveConversationChatId() === chatId ? toJid : ''));
};

// Rebuilt from the stored message, so Retry can send it again under the same id.
const toOutboxItem = (message, toJid, receiptStatus) => {
    const { msgId, msgBody = {}, metaData } = message;
    if (msgBody.message_type !== TEXT_MESSAGE_TYPE || !msgBody.message) return null;
    return {
        msgId,
        kind: OUTBOX_KIND.TEXT,
        params: {
            toJid,
            messageText: msgBody.message,
            msgId,
            replyMessageId: msgBody.replyTo || '',
            mentionedUsersIds: msgBody.mentionedUsersIds || [],
            receipt_status: msgBody.receipt_status || receiptStatus,
            ...(message.disappear_at && { disappear_at: message.disappear_at }),
            ...(metaData && typeof metaData === 'object' && { metaData }),
        },
    };
};
